var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTakeoutTurnoverMini = function SvgTakeoutTurnoverMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC903",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 0.2,
    d: "M16.478 8a3.13 3.13 0 0 0-3.13 3.13v1.202h-1.532a2.12 2.12 0 0 0-2.113 1.924l-.694 7.425A2.12 2.12 0 0 0 11.121 24h10.607a2.12 2.12 0 0 0 2.111-2.319l-.692-7.425a2.12 2.12 0 0 0-2.113-1.924h-1.427v-1.203A3.13 3.13 0 0 0 16.477 8Zm-1.644 3.13a1.644 1.644 0 0 1 3.288 0v1.113h-3.288zm-3.018 2.687h9.218c.328 0 .603.25.634.577l.694 7.425a.636.636 0 0 1-.634.696H11.121a.636.636 0 0 1-.633-.696l.694-7.425a.636.636 0 0 1 .634-.577Z"
  }))));
};
export default SvgTakeoutTurnoverMini;